<template>
  <div>
    <b-sidebar
      id="sidebar-role-promotion"
      sidebar-class="sidebar-lg"
      :visible="rolePromotionSidebar.visible"
      bg-variant="white"
      shadow
      backdrop
      no-header
      right
      @shown="onShow"
      @change="(val) => mutateRolePromotionSidebar({ visible: val })"
      @hidden="clear"
    >
      <template #default="{ hide }">
        <!-- Header -->
        <div
          class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
        >
          <h4>Solicitação de Mudança de Nível</h4>
          <div>
            <feather-icon
              class="ml-1 cursor-pointer"
              icon="XIcon"
              size="16"
              @click="hide"
            />
          </div>
        </div>

        <template v-if="promotion">
          <b-form class="m-2" @submit.prevent="onSubmit">
            <b-row>
              <b-col cols="6" class="mb-1"> Consultor: </b-col>
              <b-col cols="6" class="mb-1 text-primary">
                <b> {{ promotion.consultant && promotion.consultant.name }} </b>
              </b-col>
            </b-row>
            <b-row class="border-bottom border-top">
              <b-col cols="12" class="mb-1 mt-1">
                <b>Detalhes da solicitação</b>
              </b-col>
              <b-col cols="6" class="mb-1"> Nível Atual: </b-col>
              <b-col cols="6" class="mb-1">
                  {{ promotion.old_consultant_role && promotion.old_consultant_role.name }}
              </b-col>
              <b-col cols="6" class="mb-1"> Novo Nível: </b-col>
              <b-col cols="6" class="mb-1">
                  {{ promotion.new_consultant_role && promotion.new_consultant_role.name }}
              </b-col>
              <b-col cols="6" class="mb-1"> Status: </b-col>
              <b-col cols="6" class="mb-1">
                  {{ getStatusLabel(promotion.status) }}
              </b-col>
            </b-row>
            <b-row class="border-bottom border-top">
              <b-col cols="12" class="mb-1 mt-1">
                <b>Certificados</b>
              </b-col>
              <template v-for="certificate in promotion.certificates">
                <b-col cols="6" class="mb-1">
                  {{ certificate.certificate_type && certificate.certificate_type.name }}
                </b-col>
                <b-col cols="6" class="mb-1">
                  <b-badge
                    :variant="certificateStatusVariants[certificate.status] || 'secondary'"
                    class="ml-1"
                  >
                    {{ certificateStatusLabel(certificate.status) }}
                  </b-badge>
                </b-col>
              </template>
            </b-row>
            <b-row class="border-bottom border-top">
              <b-col cols="12" class="mb-1 mt-1">
                <b>Contratos</b>
              </b-col>
              <template v-for="document in promotion.contracts">
                <b-col cols="6" class="mb-1">
                  {{ document.description }}
                </b-col>
                <b-col cols="6" class="mb-1">
                  <b-badge
                    :variant="document.finished_at ? 'success' : 'danger'"
                    class="ml-1"
                  >
                    {{ document.finished_at ? 'Assinado' : 'Pendente' }}
                  </b-badge>
                </b-col>
              </template>
            </b-row>
            <b-row class="mt-1">
              <b-col cols="6" class="mb-1"> Data da solicitação: </b-col>
              <b-col cols="6" class="mb-1">
                {{ promotion.created_at | onlyDate }}
              </b-col>
            </b-row>

            <b-alert
              v-if="promotion.certificate_pendency"
              variant="warning"
              show
              class="mt-1"
            >
              <div class="alert-body">
                {{ promotion.certificate_pendency.message }}
                A aprovação fica bloqueada até o certificado ser aprovado.
              </div>
            </b-alert>

            <div
              v-if="$can(MANAGE_ACTION, APPROVE_CONSULTANT_ROLE)"
              class="d-flex mt-2 justify-content-between"
            >
              <b-button
                :disabled="saving.approve || saving.reprove || !isPending"
                variant="danger"
                type="submit"
                class="promotion-buttons"
                @click="status = 'reproved'"
              >
                {{ saving.reprove ? "Aguarde..." : "Reprovar" }}
              </b-button>
              <b-button
                :disabled="saving.approve || saving.reprove || !isPending || !!promotion.certificate_pendency"
                variant="success"
                type="submit"
                class="promotion-buttons"
                @click="status = 'approved'"
              >
                {{ saving.approve ? "Aguarde..." : "Aprovar" }}
              </b-button>
            </div>
          </b-form>
        </template>
        <div v-else class="d-flex justify-content-center m-2">
          <b-spinner variant="primary" />
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import {
  BSidebar,
  BForm,
  BButton,
  BCol,
  BRow,
  BSpinner,
  BBadge,
  BAlert,
} from "bootstrap-vue";
import { mapActions, mapMutations, mapGetters } from "vuex";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import Ripple from "vue-ripple-directive";
import { APPROVE_CONSULTANT_ROLE, MANAGE_ACTION } from "@/constants/resources";
import { getApiErrorMessage } from "@/helpers/error_messages";
import * as types from "../store/types";
import { certificateStatusLabel, certificateStatusVariants } from "@/constants/certificates_status";

export default {
  components: {
    BButton,
    BSidebar,
    BForm,
    BCol,
    BRow,
    BSpinner,
    BBadge,
    BAlert,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      APPROVE_CONSULTANT_ROLE,
      MANAGE_ACTION,
      certificateStatusVariants,
      promotion: undefined,
      saving: {
        approve: false,
        reprove: false,
      },
      status: undefined,
    };
  },
  setup() {
    return { toast: useToast() };
  },
  computed: {
    ...mapGetters({
      rolePromotionSidebar: types.ROLE_PROMOTION_SIDEBAR,
    }),
    isPending() {
      return this.promotion && this.promotion.status === "pending";
    },
  },
  methods: {
    certificateStatusLabel,
    ...mapMutations({
      mutateRolePromotionSidebar: types.MUTATE_ROLE_PROMOTION_SIDEBAR,
    }),
    ...mapActions({
      getRolePromotion: types.GET_ROLE_PROMOTION,
      updateRolePromotion: types.UPDATE_ROLE_PROMOTION,
    }),
    onShow() {
      this.getRolePromotion(this.rolePromotionSidebar.id)
        .then((resp) => {
          if (resp.data && resp.data.id) {
            this.promotion = resp.data;
          } else {
            throw new DOMException("Solicitação não encontrada!");
          }
        })
        .catch(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao carregar os dados da solicitação. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
          this.mutateRolePromotionSidebar({ visible: false });
        });
    },
    onSubmit() {
      if (!this.$can(MANAGE_ACTION, APPROVE_CONSULTANT_ROLE) || !this.isPending) {
        return;
      }
      if (this.status === "approved" && this.promotion.certificate_pendency) {
        return;
      }
      if (this.status === "reproved") {
        this.saving.reprove = true;
      } else {
        this.saving.approve = true;
      }
      this.updateRolePromotion({
        id: this.rolePromotionSidebar.id,
        status: this.status,
      })
        .then(() => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Sucesso",
              text: "Salvo com sucesso!",
              icon: "CoffeeIcon",
              variant: "success",
            },
          });
          this.mutateRolePromotionSidebar({ visible: false });
          this.rolePromotionSidebar.saveAction();
        })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              icon: "AlertTriangleIcon",
              text: getApiErrorMessage(error, "Ocorreu um erro ao salvar. Entre em contato com o setor de TI."),
              variant: "danger",
            },
          });
          if (error.response && error.response.status === 422) {
            this.onShow();
          }
        })
        .finally(() => {
          this.saving.reprove = false;
          this.saving.approve = false;
        });
    },
    getStatusVariant(status) {
      const variants = {
        pending: "light-warning",
        approved: "light-success",
        reproved: "light-danger",
      };
      return variants[status] || "light-secondary";
    },
    getStatusLabel(status) {
      const labels = {
        pending: "Pendente",
        approved: "Aprovado",
        reproved: "Reprovado",
      };
      return labels[status] || status;
    },
    clear() {
      this.promotion = undefined;
      this.status = undefined;
    },
  },
};
</script>
<style lang="scss">
.promotion-buttons {
  width: 11rem;
}
</style>
